import {SponsorNavigator} from "@/core/navigation/navigators/sponsor/SponsorNavigator";
import {InvestorNavigator} from "@/core/navigation/navigators/investor/InvestorNavigator";

export class Navigation {
    public readonly sponsor = new SponsorNavigator();
    public readonly investor = new InvestorNavigator();
}

export const navigation = new Navigation();
